import { render, staticRenderFns } from "./Levelbar.vue?vue&type=template&id=4c2d1dfa&scoped=true&"
import script from "./Levelbar.vue?vue&type=script&lang=js&"
export * from "./Levelbar.vue?vue&type=script&lang=js&"
import style0 from "./Levelbar.vue?vue&type=style&index=0&id=4c2d1dfa&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2d1dfa",
  null
  
)

export default component.exports